import { Component, EventEmitter, Input, Output } from '@angular/core';

type ButtonTheme = 'primary' | 'secondary';
type ButtonType = 'button' | 'submit';

@Component({
  selector: 'ez-button',
  imports: [],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() label: string;
  @Input() theme: ButtonTheme = 'primary';
  @Input() buttonType: ButtonType = 'submit';
  @Input() disabled = false;
  @Input() maxWidth = '100%';
  @Output() buttonClick = new EventEmitter<MouseEvent>();

  onClickButton(event: MouseEvent) {
    this.buttonClick.emit(event);
  }
}
